import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';

interface ScanErrorProps {
  errors: Record<'header' | 'description', string>[];
  onClose: () => void;
}

export default function ScanError({ errors, onClose }: ScanErrorProps) {
  const { t } = useTranslation();

  return (
    <div className='min-h-[calc(100vh-7rem)] grid place-content-center max-w-5xl mx-auto py-8 px-6'>
      <div className='flex flex-col max-w-xl gap-4 mx-auto space-y-8'>
        <div className='space-y-6'>
          <div className='space-y-1'>
            <h2 className='text-xl font-semibold text-center'>{t('error')}</h2>
            <p className='leading-tight'>{t('scan_error_info')}</p>
          </div>

          {errors.length ? (
            <div className='space-y-4'>
              {errors.map(({ header, description }) => (
                <div className='max-w-lg space-y-1' key={header}>
                  <h2 className='font-semibold'>{header}</h2>
                  <p className='leading-tight text-gray-500'>{description}</p>
                </div>
              ))}
            </div>
          ) : null}
        </div>

        <div className='flex flex-col items-center justify-center gap-2'>
          <Button className='px-6 h-9' onClick={onClose}>
            {t('close')}
          </Button>
        </div>
      </div>
    </div>
  );
}
